import mori from 'mori';
import { appDefault } from '../config/config';

export default {
  columnDefs: [],
  rowData: null,
  enableSorting: true,
  enableFilter: true,
  enableColResize: false,
  suppressAutoSize: true,
  suppressMultiSort: true,
  autoSizePadding: 50,
  forPrint: false,
  minColWidth: 50,
  colWidth: 200,
  headerHeight: 30,
  rowBuffer: 50,
  // Only remove if you have a good reason. Allows periods in field names
  suppressFieldDotNotation: true,
  // no more dragging column headers
  suppressMovableColumns: true,
  // Can't select cells
  suppressCellSelection: true,
  // Don't hide the menu
  suppressMenuHide: true,
  // It's faster NOT to use angluar to compile table stuff
  angularCompileHeaders: false,
  angularCompileRows: false,
  unSortIcon: true,
  icons: {
    sortAscending: () => (`<span />`),
    sortDescending: () => (`<span />`),
    sortUnSort: () => (`<span />`),
  },
  getRowClass: function(params) {
    const classes = [];
    // @TODO We can test for summary rows in Location or State context, but
    // not for multigeo cases base column is Parent Firm or other.
    // Could use some expensive extended cases here, or figure out how to
    // access the base column header context
    const baseDistribution = params.data.Location || params.data.State;

    if (appDefault.specialWrapups.indexOf(baseDistribution) >= 0 ||
        appDefault.isSummaryRow.test(baseDistribution) ||
        params.data.isSummary
      ) {
      classes.push('wrapup');
    }

    if (params.node.rowHeight > 30) {
      classes.push('multiline');
    }

    return classes;
  },
};

export function getDefaultStates(columns) {
  // Super hacky, but hey it works ¯\_(ツ)_/¯
  // Convert US, and States in data.columns to
  // #{"Location" "Geography"}: "[Label]"
  return mori.into(
    mori.vector(
      mori.vector(
        mori.hashMap(mori.set(['Location', 'Geography']), 'United States')
      )
    ),
    mori.map(
      (item) => mori.vector(
        mori.hashMap(
          mori.set(['Location', 'Geography']),
          mori.get(mori.last(item), 'label')
        )
      ),
      mori.toClj(columns.nested.states.children)
    )
  );
}

// This is the locationFiltering function
export function LocationFilter() {}
LocationFilter.prototype.init = function(params) {
  this.field = params.colDef.field;
  this.valueGetter = params.valueGetter;
};
 // Required, but not used
LocationFilter.prototype.getGui = function() { return ''; };
LocationFilter.prototype.isFilterActive = function() {
  return this.value.length > 0;
};
LocationFilter.prototype.doesFilterPass = function(params) {
  return this.value.indexOf(params.data[this.field]) > -1;
};
LocationFilter.prototype.getApi = function() {
  const _this = this;
  return {
    getField: function() {
      return _this.field;
    },
    getModel: function() {
      return { 'value': _this.value };
    },
    setModel: function(model) {
      _this.value = model.map((curr) =>
        (curr.indexOf(' (All)') > -1) ? curr.split(' (All)')[0] : curr);
    },
  };
};



// WEBPACK FOOTER //
// ../datacenter/app/js/config/table.js